import React from "react";
import { Button, Col, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { IUserData } from "../../../../core";
import UserDataFormField from "./user-data-form-field.component.tsx";

interface IUserDataFormProps {
   handleFormSubmit: (e: any) => Promise<false | undefined>;
   formValidate: boolean;
   isLoading: boolean;
   setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
   formData: IUserData;
   setFormData: React.Dispatch<React.SetStateAction<IUserData>>;
   invalidFields: Array<string>;
   formFields: IUserData;
}

export const UserDataForm: React.FC<IUserDataFormProps> = (
   { handleFormSubmit, formValidate, isLoading, setIsLoading, formData, setFormData, invalidFields = [], formFields }
) => {
   const { t } = useTranslation('core');
   const navigate = useNavigate();

   const handleDeleteAccount = () => {
      navigate("/account/delete-account");
   }

   const handleChange = (key, value) => {
      setFormData((prevData) => ({
         ...prevData,
         [key]: value || "",
      }));
   };

   return (
      <Col xs={12} sm={12} md={12} lg={8} className="px-5 border-start">
         <h5 className="mb-3">{t('profileTitle')}</h5>
         <Form onSubmit={handleFormSubmit} noValidate validated={formValidate}>
            <fieldset disabled={isLoading}>
               {Object.entries(formFields).map(([key, config]) => (
                  <UserDataFormField
                     translate={t}
                     key={key}
                     value={formData[key] || ""}
                     onChange={(e) => handleChange(key, e.target.value)}
                     setIsLoading={setIsLoading}
                     config={config}
                     isInvalid={invalidFields.includes(key)}
                     formData={formData}
                     setUserData={handleChange}
                  />
               ))}
               <div className="d-grid gap-2">
                  <Button variant="primary" type="submit">
                     {t('submitButtonLabel')}
                  </Button>
               </div>
               <div className="d-grid gap-2 mt-5">
                  <Button variant="" type="button" className="text-secondary" onClick={handleDeleteAccount}>
                     <small>{t('deleteAccount')}</small>
                  </Button>
               </div>
            </fieldset>
         </Form>
      </Col>
   );
}
